import type {
  MeetingTemplateItem,
  MeetingTemplateScope,
} from '@wundo/shared/meetingTemplate.ts';

/**
 * The list with one of its two sections rearranged and the other left alone.
 *
 * The server hands both sections down as one list, the organisation's first,
 * so a move inside one of them is written back in place: the ids that were
 * named take that section's own slots, in the order they were named. Ids the
 * list no longer holds are dropped rather than guessed at — the refetch that
 * follows every move has the last word anyway.
 */
export function orderTemplateSection(
  templates: MeetingTemplateItem[],
  scope: MeetingTemplateScope,
  ids: string[],
): MeetingTemplateItem[] {
  const moved = ids
    .map((id) => templates.find((template) => template.id === id))
    .filter((template) => template !== undefined);
  const rest = templates.filter((template) => template.scope !== scope);

  return scope === 'organisation' ? [...moved, ...rest] : [...rest, ...moved];
}
